import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Transforms } from 'slate';
import TableUtils from '../TableUtils';

// Make the table take up 100% of the width (useful after it has been manually resized).
class ToolTableFullWidth extends Tool {
  static toolName = 'Use full width';
  static iconClass = 'fa-regular fa-arrows-left-right-to-line';

  static action({ editor }: ToolArgs): void {
    if (!editor?.selection) return;

    const path = TableUtils.currentTablePath(editor);
    if (!path) return;

    Transforms.unsetNodes(editor, 'table_width', { at: path });
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return Boolean(tableElement.table_width);
  }
}

export default ToolTableFullWidth;
